import { Prec, RangeSetBuilder } from '@codemirror/state';
import { Decoration, ViewPlugin } from '@codemirror/view';

import type { Extension } from '@codemirror/state';
import type { DecorationSet, ViewUpdate, EditorView } from '@codemirror/view';

const liquidTagDecoration = Decoration.mark({
  class: 'cm-liquid-tag',
});
const liquidVariableDecoration = Decoration.mark({
  class: 'cm-liquid-variable',
});

const liquidHighlighter = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = this.buildDecorations(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = this.buildDecorations(update.view);
      }
    }

    buildDecorations(view: EditorView): DecorationSet {
      const builder = new RangeSetBuilder<Decoration>();
      const text = view.state.doc.toString();

      // Collect all matches with their positions
      const matches: Array<{ from: number; to: number; decoration: Decoration }> = [];

      // Match Liquid tags: {% ... %}
      const tagPattern = /\{%[^%]*%\}/g;
      let match;
      while ((match = tagPattern.exec(text)) !== null) {
        matches.push({
          from: match.index,
          to: match.index + match[0].length,
          decoration: liquidTagDecoration,
        });
      }

      // Match Liquid variables: {{ ... }}
      const variablePattern = /\{\{[^}]*\}\}/g;
      while ((match = variablePattern.exec(text)) !== null) {
        matches.push({
          from: match.index,
          to: match.index + match[0].length,
          decoration: liquidVariableDecoration,
        });
      }

      // Sort by position before adding to builder (RangeSetBuilder requires sorted input)
      matches.sort((a, b) => a.from - b.from);

      for (const m of matches) {
        builder.add(m.from, m.to, m.decoration);
      }

      return builder.finish();
    }
  },
  {
    decorations: (v) => v.decorations,
  },
);

export const createLiquidHighlightExtension = (): Extension[] => {
  return [Prec.highest(liquidHighlighter)];
};
